module.exports = __webpack_public_path__ + "static/media/washer-dark-gray.7a3e16dd.svg";